<template>
  <div class="divider-component" :style="{ width }"></div>
</template>
<script lang="ts" setup>
import { CSSProperties, computed, inject } from 'vue'
import { sharedDataKey } from '@/components/types'

const sharedData = inject(sharedDataKey)
const fullscreen = computed(() => sharedData?.fullscreen ?? false)

type Props = {
  width?: CSSProperties['width']
  fullscreenWidth?: CSSProperties['width']
}
const props = withDefaults(defineProps<Props>(), {
  width: 'auto',
  fullscreenWidth: '100%'
})
const width = computed(() => (fullscreen.value ? props.fullscreenWidth : props.width))
</script>
<style lang="scss" scoped>
.divider-component {
  height: 1px;
}
</style>
